module.exports = __webpack_public_path__ + "static/img/scene9.248f3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene9.jpg
// module id = PDRQ
// module chunks = 1